<template>
  <el-dialog title="设置摄像头" :visible.sync="editVisible" width="600px" :before-close="handleClose" :close-on-click-modal="false" center>
    <div class="form-body">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="auto" class="demo-ruleForm">
        <el-form-item label="摄像头名称" prop="cameraName">
          <el-input v-model="ruleForm.cameraName" style="width:400px;margin-right:5px;"/>
        </el-form-item>
        <el-form-item label="摄像头编号" prop="cameraSn">
          <el-input v-model="ruleForm.cameraSn" style="width:400px;margin-right:5px;"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        id: null,
        project: null,
        cameraSn: null,
        cameraName: null,
      },
      rules: {
        cameraSn: [
          {
            required: true,
            message: "请设置摄像头编号",
            trigger: "blur",
          }
        ],
        cameraName: [
          {
            required: true,
            message: "请设置摄像头名称",
            trigger: "blur",
          }
        ]
      },
    };
  },
  computed: {
    ...mapState(["buttonTextColor"]),
  },
  props: ["editVisible","projectCamera"],
  watch: {
    editVisible(newValue) {
      if (newValue) {
       this.ruleForm={
        id: this.projectCamera.id,
        project: this.projectCamera.project,
        cameraSn: this.projectCamera.cameraSn,
        cameraName: this.projectCamera.cameraName,
       }
      }
    },
  },
  methods: {
    onInput() {
      this.$forceUpdate();
    },
    handleClose() {
      this.ruleForm = {};
      this.$emit("handleClose");
    },
    submit() {
      this.$refs["ruleForm"].validate((valid) => {
          if (valid) {
            this.request.cameraEdit(this.ruleForm).then((res) => {
              if (res.code==0) {
                this.$message.success("设置成功");
                this.$emit("handleClose");
              }
            });
          }
        });
    },
  },
};
</script>
<style scoped>
.form-body {
  width:550px;
  display:flex;
  flex-direction:row;
  justify-content:center;
  box-sizing:border-box;
}
</style>